module.exports = __webpack_public_path__ + "img/lightbulbs.7ca23e0.webp";